import { FieldHasValue } from 'helpers/Validation';

export const AsFoundResultFormula = (formData) => {
    if (FieldHasValue(formData.F407AftTestMethodApplied) && FieldHasValue(formData.F372AftHmistatus1)) {
        if (formData.F407AftTestMethodApplied === 'YES' && formData.F372AftHmistatus1 === 'ALARM') {
            return 'PASS';
        }
        return 'FAIL';
    }
    return '';
};
